import { sleep } from '@istrugatskiy/mamk-utils';
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, User } from 'firebase/auth';
import {
    deleteDoc,
    deleteField,
    doc,
    getDoc,
    getFirestore,
    onSnapshot,
    setDoc,
    updateDoc,
} from 'firebase/firestore';

const firebaseConfig = {
    apiKey: 'AIzaSyD68rrRmne8-DPYBXn2c3dhBszfCUJloxM',
    authDomain:
        window.location.host === 'localhost:1234'
            ? 'temp42-65e95.firebaseapp.com'
            : 'temp42.mamklearn.com',
    projectId: 'temp42-65e95',
    storageBucket: 'temp42-65e95.firebasestorage.app',
    messagingSenderId: '155177910278',
    appId: '1:155177910278:web:9f2be53a1eedde48904387',
};

export const app = initializeApp(firebaseConfig);
export const provider = new GoogleAuthProvider();
export const auth = getAuth(app);
export const db = getFirestore(app);

export const get_me = async (user: User) => {
    try {
        const me = doc(db, 'user', user.uid);
        const me_data = (await getDoc(me)).data();
        if (me_data === undefined) {
            const default_user = {
                current_game: null,
                handshake: '',
                server: '',
                client_ice: '',
                server_ice: '',
            };
            await setDoc(me, default_user);
            return default_user;
        }
        return me_data;
    } catch (e: unknown) {
        console.warn('No access, contact sheep support');
        console.warn(e);
        return undefined;
    }
};

export const leave_game = async (user: User, code: string) => {
    const game = doc(db, 'games', code);
    try {
        await deleteDoc(game);
    } catch (e: unknown) {
        try {
            await updateDoc(game, {
                [`players.${user.uid}`]: deleteField(),
            });
        } catch (e: unknown) {
            console.warn('Inconsistent state');
            console.warn(e);
        }
    }
    const me = doc(db, 'user', user.uid);
    await updateDoc(me, {
        current_game: null,
        handshake: '',
        server: '',
        server_ice: '',
        client_ice: '',
    });
};

export const join_game = async (user: User, code: string) => {
    // If you try to concurrently spam on two tabs, one of them might crash...
    // but thats not a big deal, so don't really care.
    const me = await get_me(user);
    const me_ref = doc(db, 'user', user.uid);
    if (me?.current_game && typeof me.current_game === 'number') {
        await leave_game(user, me.current_game.toString());
    }
    await updateDoc(me_ref, {
        current_game: Number(code),
        handshake: '',
        server: '',
        client_ice: '',
        server_ice: '',
    });
    await updateDoc(doc(db, 'games', code), {
        [`players.${user.uid}`]: user.displayName,
    });
};

export const create_game = async (user: User) => {
    const me = await get_me(user);
    const me_ref = doc(db, 'user', user.uid);

    if (me?.current_game !== undefined && typeof me.current_game === 'number') {
        await leave_game(user, me.current_game.toString());
    }

    for (let i = 0; i < 10; i++) {
        try {
            const random = new Uint32Array(1);
            crypto.getRandomValues(random);
            const code = (random.at(0)! % (1_000_000 - 100_000 + 1)) + 100_000;
            await updateDoc(me_ref, {
                current_game: code,
                handshake: '',
                server: '',
                client_ice: '',
                server_ice: '',
            });
            await setDoc(doc(db, 'games', code.toString()), {
                owner: user.uid,
            });
            return code;
        } catch (e: unknown) {
            console.warn(e);
            await updateDoc(me_ref, {
                current_game: null,
                handshake: '',
                server: '',
                client_ice: '',
                server_ice: '',
            });
        }
    }
    return undefined;
};
